import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    // secondary: "linear-gradient(88.43deg, #FA9145 2.67%, #C5532D 96.44%)",
    primary: " #AB3006",
    menuactive: "#F9A826",
  });

  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved) setTheme(JSON.parse(saved));
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--primary-color", theme.primary);
    document.documentElement.style.setProperty("--sideMenu-active-item-color", theme.menuactive);
    // document.documentElement.style.setProperty("--secondary-color", theme.secondary);
    localStorage.setItem("theme", JSON.stringify(theme));
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
